window.Reverb = window.Reverb || {};

Reverb.RemoteCheckbox = (function () {
  const checkboxes = '[data-ajax-checkbox]';
  const doneEvent = 'reverb:remote-checkbox:done';

  function init() {
    handleRemoteCheckboxes();
  }

  function handleRemoteCheckboxes() {
    $(document).on('click', checkboxes, function (e) {
      submit($(this));
    });
  }

  function submit($checkbox, options) {
    options = options || {};
    options.url = options.url || $checkbox.data('url');

    const method = $checkbox.is(':checked') ? 'post' : 'delete';

    $.ajax({
      type: method,
      url: options.url,
    }).done(() => {
      $checkbox.trigger(doneEvent);
      if (options.done) { options.done.call($checkbox); }
      $checkbox.parent('label').highlight();
    });
  }

  return {
    init,
    submit,
  };
}());

$(Reverb.RemoteCheckbox.init);
